import { render, staticRenderFns } from "./ExternalButton.vue?vue&type=template&id=d48ef836&scoped=true"
import script from "./ExternalButton.vue?vue&type=script&lang=js"
export * from "./ExternalButton.vue?vue&type=script&lang=js"
import style0 from "./ExternalButton.vue?vue&type=style&index=0&id=d48ef836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48ef836",
  null
  
)

export default component.exports